module.exports = __webpack_public_path__ + "static/media/circle-arrrow.dafe702d.svg";